
<ng-container *ngIf="isLoaded">
  <div class="modal-close-btn" (click)="closeModal()">X</div>
  <div class="card mb-3">
    <div class="card-body">
      <div class="pt-4 pb-2">
        <h5 class="card-title text-center pb-0 fs-4">Създаване на Посредник</h5>
        <p class="text-center small">Моля, въведете основните данни на Посредника</p>
      </div>

      <form [formGroup]="Form" class="row g-3 needs-validation" (ngSubmit)="onSubmit()">
        <div class="col-12">
          <label for="agentName" class="form-label">Име</label>
          <input type="text" formControlName="agentName" class="form-control" id="agentName">
        </div>
        <div class="col-12">
          <label for="agentEIK" class="form-label">ЕИК</label>
          <input type="text" formControlName="agentEIK" class="form-control" id="agentEIK">
        </div>
        <div class="col-12">
          <label for="agentEIK" class="form-label">Основна Комисионна</label>
          <input type="text" formControlName="agentEIK" class="form-control" id="agentEIK">
        </div>
        <div class="col-12">
          <div class="form-check">
            <input class="form-check-input" type="checkbox" formControlName="isActive" id="isActive">
            <label class="form-check-label" for="isActive">Активен</label>
          </div>
        </div>
        <div class="col-12">
          <button class="btn btn-primary w-100" type="submit" [disabled]="!Form.valid">Създай</button>
        </div>
      </form>
    </div>
  </div>

</ng-container>
